import './styles/index.less'
import formPageDesign from './formPageDesign'
import formDesign from './formDesign'
import formViewer from './formViewer'

import config from '../package.json'

const prototypes = {
}
const components = {
  formPageDesign,
  formDesign,
  formViewer,
}

const install = function (Vue) {
  if (install.installed) {
    return
  }

  Object.values(components).map(component => {
    Vue.use(component)
  })

  Object.keys(prototypes).forEach((key) => {
    Vue.prototype['$' + key] = prototypes[key];
  });
}

//  全局引用可自动安装
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
  window.learun_form ={
    name:config.name,
    version:config.version,
    company:config.company
  }
}

export default {
  install,
  ...components
}

export {
  components
}
